import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import type { VariantProps } from 'class-variance-authority';
import { CircleNotchIcon } from '@phosphor-icons/react';
import * as React from 'react';
import { buttonVariants } from './button-variants';

type BaseButtonProps = React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & { asChild?: boolean };

function BaseButton({ className, variant, size, asChild = false, ...props }: BaseButtonProps) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

interface ButtonProps extends BaseButtonProps {
  isLoading?: boolean;
  loadingText?: string;
}

function Button({ isLoading = false, loadingText, ...buttonProps }: ButtonProps) {
  if (isLoading) {
    if (buttonProps.size === 'icon') {
      return (
        <BaseButton {...buttonProps} disabled>
          <CircleNotchIcon className="h-4 w-4 animate-spin" />
        </BaseButton>
      );
    }

    return (
      <BaseButton {...buttonProps} disabled>
        <CircleNotchIcon className="mr-2 h-4 w-4 animate-spin" />
        {loadingText || 'Loading'}
      </BaseButton>
    );
  }

  return <BaseButton {...buttonProps} />;
}

export { Button };
